import { Pipe, PipeTransform } from '@angular/core';
import { WhatsappGroup } from 'src/models/whatsappGroup';

@Pipe({
    name: 'filterByWhatsappGroup',
    pure: false
})
export class FilterByWhatsappGroupPipe implements PipeTransform {
    transform(items: WhatsappGroup[], name: string): any {
        return name ? items.filter(item =>
            item.GroupName?.toLowerCase().indexOf(name.toLowerCase()) > -1) : items;
    }
}
